import React from 'react';
import {
  Container
} from 'react-bootstrap';
import ReactPlayer from 'react-player';
import { Tron } from './Tron';

export const Usage = () => {
  
  let homeTron = {
    title: 'Workspace ONE Excel Add-In (Beta)',
    description: 'This is the Usage Page for the Workspace ONE Excel Add-In.',
    body: <><p>The Workspace ONE Excel Add-In takes the complication out of accessing your Workspace ONE UEM
      API's
      and importing that data into Excel. This is a live sheet which you can update at any time and
      even
      copy
      into a different Office Application (eg. Word or Powerpoint) and maintain the connection to the
      live
      data your environment.</p>
      <p>Below you will find the step by step instructions to connect this tool to your Workspace ONE
        UEM API server.</p></>
  };
  
  
  return (
    
    <Container>
      <Tron tronProps={homeTron}/>
      <Container>
        <h3>Video Deep dive on functionality</h3>
        <ReactPlayer url="https://www.youtube.com/embed/wzPhwvfvH1M" config={{
          youtube: {
            playerVars: { showinfo: 1, controls: true }
          }
        }}>
        </ReactPlayer>
        
        <ul>
          <li>
            <>Sign in to Workspace ONE. Then click on Groups and Settings, then All Settings</>
            <br/>
            <img alt="Sign in to Workspace ONE" src="../images/WSOneSettings.png" width="500"/>
          </li>
          <li>
            <>In the Settings pane, select System, then Advanced, then API, then REST API</>
            <br/>
            <img alt="Go to Dashboards" src="../images/WSOneSelectRest.png" width="500"/>
          </li>
          <li>
            <>One the REST API page, you will see the API keys which have been created. You have
              a choice of creating a new API key to use for this tool or using an existing one.
            </>
            <p>I would strongly suggest creating a new admin API key to use for this tool. </p>
            <br/>
            <img alt="Click on the title" src="../images/WSOneCopyOrCreateAPIKey.png" width="500"/>
          </li>
          <li>
            <>You should create an admin account which you will use with the tool as well. This will alow you
              to create a role which has read-only abilities on the API.
            </>
            <br/>
            <img alt="Copy the Chart Number" src="../images/WSOneCreateAdminAccount.png" width="500"/>
          </li>
          <li>
            <>Next you should create an admin Role which has read-only abilities on the API. Click
              Accounts-{'>'}Administrators-{'>'}Roles.
            </>
            <br/>
            <img alt="Copy the Chart Number" src="../images/WSOneRoles.png" width="500"/>
          </li>
          <li>
            <>Add a Role and give it Read Only abilities on the API.</>
            <br/>
            <img alt="Copy the Chart Number" src="../images/WSOneCreateAPIReportingRole.png" width="500"/>
          </li>
          <li>
            <>Finally go back to your ApiReporting Admin account and assign it to only have the new
              APIReporting
              Role.
            </>
            <br/>
            <img alt="Copy the Chart Number" src="../images/WSOneAssignReportingRoleToAdmin.png" width="500"/>
          </li>
          <li>
            <>Switch to Excel, click on the Workspace ONE Add-In icon to open the add-in.</>
            <br/>
            <img src="../images/WSOneVerifyAddIn.png" alt="Open Addin" width="500"/>
          </li>
          <li>
            <>Then click Login.</>
            <br/>
            <img src="../images/WSOneHomePage.png" alt="Login to Addin" width="500"/>
          </li>
          <li>
            <>Next you will enter the following and click Login:</>
            <ul>
              <li>Username: Your API admin username</li>
              <li>Password: Your API admin password</li>
              <li>Apikey: The apikey you generated to allow read-only access to your api</li>
              <li>Domain: The domain name of the environment you manage = eg. asXX.awmdm.com</li>
              <p>Usually the name is asxxx since that is the API server prefix</p>
            </ul>
            <img src="../images/WSOneLoginPage.png" alt="Paste Chart Number" width="500"/>
          </li>
          <li>
            <>Once you have logged in, There are multiple tabs to choose from where you can retrieve data from
              your
              API.
            </>
            <br/>
            <img src="../images/WSOneLoggedIn.png" alt="Paste Chart Number" width="300"/>
          </li>
        </ul>
      
      </Container>
    </Container>
  );
};

